import ReferralVerified from '../components/referral-verified'

export default function ReferralSuccessPage() {
  return <ReferralVerified />;
}
